import styled from 'styled-components';
import ClientIcon from '@/icons/Client';
import { Breakpoints } from '@/styles/breakpoints';

type Props = {
    className?: string;
};

const UnstyledGhostClientListItem = ({ className }: Props) => {
    return (
        <div className={className}>
            <ClientName>
                <ClientIcon strokeColor="uNavy" fillColor="uNavy10" />
                <GhostBlock style={{ width: '80px' }} />
                <GhostBlock style={{ width: '100px' }} />
            </ClientName>

            <GhostBlock style={{ width: '200px' }} />

            <GhostBlock style={{ width: '180px' }} />

            <GhostButton />
        </div>
    );
};

const GhostBlock = styled.div`
    height: 8px;
    border-radius: 2px;
    background-color: ${({ theme }) => theme.colors.uNavy20};
`;

const GhostButton = styled.div`
    width: 145px;
    height: 40px;
    background-color: ${({ theme }) => theme.colors.uNavy20};
    border-radius: 8px;
`;

const ClientName = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;

    @media (min-width: ${Breakpoints.Small}) {
        gap: 20px;
    }
`;

export const GhostClientListItem = styled(UnstyledGhostClientListItem)`
    display: flex;
    padding: 12px;
    gap: 20px;
    align-items: center;
    justify-content: space-between;
    background-color: ${({ theme }) => theme.colors.white};
    border-radius: 8px;
`;
